export const truncateString = (str, num) => {
  // Ensure str is not null or undefined, and convert it to a string if needed
  const strNew = str ? String(str) : '';

  if (strNew.length <= num) {
    return strNew;
  }

  return strNew.slice(0, num) + '...';
};
